import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DEFAULTS = {
  support_email: 'support@beeweddi.com',
  grievance_email: 'privacy@beeweddi.com',
  legal_email: 'legal@beeweddi.com',
  phone: '+91 95000 00000',
  whatsapp: '+91 95000 00000',
  address: 'Tamil Nadu, India',
  jurisdiction_city: 'Coimbatore',
  company_name: 'BeeWeddy',
  owner_name: 'Vignesh',
};

let cache = null;
let cachePromise = null;

const fetchSiteSettings = async () => {
  if (cache) return cache;
  if (cachePromise) return cachePromise;
  cachePromise = axios
    .get(`${BACKEND_URL}/api/site-settings`)
    .then((res) => {
      cache = { ...DEFAULTS, ...(res.data || {}) };
      return cache;
    })
    .catch(() => {
      cache = DEFAULTS;
      return cache;
    })
    .finally(() => { cachePromise = null; });
  return cachePromise;
};

export const invalidateSiteSettingsCache = () => { cache = null; };

const useSiteSettings = () => {
  const [settings, setSettings] = useState(cache || DEFAULTS);
  useEffect(() => {
    let alive = true;
    fetchSiteSettings().then((s) => { if (alive) setSettings(s); });
    return () => { alive = false; };
  }, []);
  return settings;
};

export default useSiteSettings;
